import type { FaireProductEntity } from "../../entity_types/product";

export const p_mt2w9euhd6: FaireProductEntity = {
  token: "p_mt2w9euhd6",
  type: "product",
  name: "Smoked Teriyaki munchrooms",
  brandToken: "b_8yolqle2um",
  brandName: "munchrooms",
  imageUrl:
    "https://cdn.faire.com/fastly/b7629268b4b5387ecc44a783b478b70a107c24c51711eedb1fc60c8b8533a172.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d543c4c0136a73e7c67285fab11b9ce79845cd8361fa62931bb6c4a55ab0539.png",
    "https://cdn.faire.com/fastly/b401aadff29fdec15ef48e981ef21991edadc0b62f95aa7bf3c5df8e2ee8f3de.png",
    "https://cdn.faire.com/fastly/52a1cee7e2da35dbb66e5ab1200f08cf055fca09b8a26880851716f8f3a5afd0.jpeg",
    "https://cdn.faire.com/fastly/f4ad024ecfb33efc90ae3306fb62bd461733d6ae4e86e5d1b46bf91c5f69b54e.png",
    "https://cdn.faire.com/fastly/8841de8cf6a3310482a68a098151ddbf4842b07137f026ff50f3e33c82b4bc6d.png",
  ],
  priceDollars: 5,
  description:
    "Smoked Teriyaki—rich in umami with a sweet, smoky & hickory full-bodied flavor.\n\nOur jerky is delicious and made for carnivores and plant-lovers alike. With a healthy serving of fiber in each pack, munchrooms will keep you fuller for longer.  \n\nOur mushroom jerky combines the subtle umami of mushrooms, flavorful seasoning, and a meaty, satisfying texture. The rich and chewy nature of our jerky makes it easy to forget you’re munching on a meat-less snack!\n\nIngredients: Shiitake mushrooms, salt, soy sauce, sugar, five spice powder, white pepper, teriyaki seasoning powder [(soy sauce powder (maltodextrin, salt, wheat hydrolyzed protein, hydrolyzed soybean protein), yeast extract, sucrose, cabbage extract], potassium sorbate (preservative)",
  tags: [],
  msrpDollars: 7.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:23.402Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
